<template>
  <AccordionItem ref="accordionItem" :value="`filter-accordion-${props.index}`" as-child class=":not(:first-child):border-t border-b border-border-medium">
    <li>
      <AccordionHeader as-child @click="scrollUp">
        <AccordionTrigger class="group flex w-full flex-col py-6 text-lg font-medium">
          <span class="flex w-full items-center justify-between overflow-hidden group-hover:underline">
            {{ props.name }}
            <Icon class="size-6 transition-transform ease-in-out group-data-[state=closed]:rotate-180" name="chevron-up" />
          </span>
          <span v-show="props.subName" class="mt-2 hidden text-left text-base font-normal text-text-medium group-data-[state=closed]:block">{{ props.subName }}</span>
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent
        ref="accordionContent"
        class="overflow-hidden px-8 pb-1 data-[state=closed]:animate-accordion-close data-[state=open]:animate-accordion-open sm:px-0 sm:pb-0"
      >
        <slot :update-height="updateHeight" />
      </AccordionContent>
    </li>
  </AccordionItem>
</template>

<script setup lang="ts">
import { AccordionItem, AccordionHeader, AccordionTrigger, AccordionContent } from 'reka-ui'

const props = withDefaults(
  defineProps<{
    index?: number | undefined
    name?: string
    subName?: string
  }>(),
  {
    index: undefined,
    name: '',
    subName: '',
  }
)

const accordionItem = useTemplateRef('accordionItem')
const accordionContent = useTemplateRef('accordionContent')

const updateHeight = (height: number) => {
  accordionContent.value?.$el.style.setProperty('--reka-accordion-content-height', `${height}px`)
}

const scrollUp = () => {
  const item = accordionItem.value

  if (item?.open) {
    setTimeout(() => {
      item.$el.scrollIntoView({ behavior: 'smooth' })
    }, 225)
  }
}
</script>
